// extracted by mini-css-extract-plugin
export default {"draggableItem":"form-item-draggable_draggableItem__8aVhx","icon":"form-item-draggable_icon__RNUaC"};